import { t } from "@/i18n-js/instance";
import { getPlanAddonPrice } from "@/react/helpers/planAddonHelpers";
import { planFeatures } from "@/react/helpers/plansHelpers";
import { planTiers } from "@circle-react/helpers/planHelpers";
import { Loader } from "@circle-react-uikit/Loader";
import { FeatureRow } from "../FeatureRow";
import { usePlans } from "../PlansContext";
import { SectionWrapper } from "./SectionWrapper";

export const LiveStreamsAddons = () => {
  const { plans, isPlansLoading } = usePlans();

  if (isPlansLoading) {
    return <Loader center />;
  }

  return (
    <SectionWrapper
      sectionName={t("settings.billing.add_ons.live_stream.title")}
    >
      <FeatureRow
        title={t("settings.billing.add_ons.live_stream.live_attendees")}
        professional={t(
          "settings.billing.add_ons.live_stream.live_attendees_professional",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.live_stream_max_spectator_capacity,
            ),
          },
        )}
        enterprise={t(
          "settings.billing.add_ons.live_stream.live_attendees_enterprise",
        )}
        business={t(
          "settings.billing.add_ons.live_stream.live_attendees_business",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.business,
              planFeatures.live_stream_max_spectator_capacity,
            ),
          },
        )}
      />
      <FeatureRow
        title={t("settings.billing.add_ons.live_stream.hours")}
        professional={t(
          "settings.billing.add_ons.live_stream.hours_professional",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.live_stream_monthly_stream_hours,
            ),
          },
        )}
        enterprise={t("settings.billing.add_ons.live_stream.hours_enterprise", {
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.live_stream_monthly_stream_hours,
          ),
        })}
        business={t("settings.billing.add_ons.live_stream.hours_business", {
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.live_stream_monthly_stream_hours,
          ),
        })}
      />
      <FeatureRow
        title={t("settings.billing.add_ons.live_stream.video_storage")}
        professional={t(
          "settings.billing.add_ons.live_stream.video_storage_professional",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.live_stream_recording_hours,
            ),
          },
        )}
        enterprise={t(
          "settings.billing.add_ons.live_stream.video_storage_enterprise",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.enterprise,
              planFeatures.live_stream_recording_hours,
            ),
          },
        )}
        business={t(
          "settings.billing.add_ons.live_stream.video_storage_business",
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.business,
              planFeatures.live_stream_recording_hours,
            ),
          },
        )}
      />
    </SectionWrapper>
  );
};
